/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import { Snackbar, ProjectorShimmer } from 'Components';
import { AxiosCancelToken, dataFetcher, endpoints } from 'Api';
import { AppContext } from 'Context';
import { isNewUIEnabled } from 'hooks/useNewUI';
import { Pathname } from 'Routes';
import UserRequest from './UserRequest';
import { ViewerPage } from '../components/page';
import styles from './index.module.css';
import AddSuccessorModal from '../../settings/connected-accounts/Modals/AddSuccessorModal';
import { SuccessorsClassic } from './SuccessorsClassic';

// Lucide icons (MIT) for the table header labels — same as the /viewers list.
const lucideHeaderProps = {
  width: 15,
  height: 15,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
};
const IconUser = () => (
  <svg {...lucideHeaderProps}>
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const IconMail = () => (
  <svg {...lucideHeaderProps}>
    <rect width="20" height="16" x="2" y="4" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);
const IconActions = () => (
  <svg {...lucideHeaderProps}>
    <path d="M20 7h-9" />
    <path d="M14 17H5" />
    <circle cx="17" cy="17" r="3" />
    <circle cx="7" cy="7" r="3" />
  </svg>
);

const defaultSnackbar = { isVisible: false, type: undefined, message: undefined };

const SuccessorsNew = () => {
    // eslint-disable-next-line no-script-url
    window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const [snackbar, setSnackbar] = useState(defaultSnackbar);
  const [addSuccessorModal, openAddSuccessorModal] = useState(false);
  const { langText, subscriptionDetails } = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();
  const successorText = langText?.viewersSideBar?.successor;
  const commonText = langText?.common;
  const noPlan = !subscriptionDetails?.has_activePlan;
  const freePlan = parseInt(subscriptionDetails?.subscription?.plan_type, 10) === 3;
  const freePlanMsg = 'Successors can only be added with the purchase of a plan';
  const newPlanMsg = 'Successors can only be added with purchase plans';
  const freePlanAction = 'Upgrade';
  const newPlanAction = 'Purchase';

  // Read from the SWR cache so returning to this tab paints the cached list
  // instantly (revalidateOnMount keeps it fresh); mutate() refetches after add.
  const { data: successorsResp, mutate: fetchMySuccessor } = useSWR(
    [endpoints.getMySucessors],
    {
      fetcher: (url) => dataFetcher(url),
      revalidateOnMount: true,
    }
  );
  const successors = successorsResp?.success && successorsResp.data ? successorsResp.data : undefined;

  useEffect(() => {
    if (location.search?.includes(Pathname.addSuccessor)) {
      openAddSuccessorModal(true);
    } else {
      openAddSuccessorModal(false);
      navigate(location.pathname);
    }
  }, [location.search]);

  const manageSuccessorModal = () => {
    openAddSuccessorModal(false);
    navigate(location.pathname);
  };

  const actionAfterAddSuccessor = () => {
    fetchMySuccessor();
  };

  return (
    <>
      <ViewerPage
        title={successorText?.title || 'Successors'}
        addActionName={successorText?.newSuccessor || 'New Successor'}
        link={noPlan || freePlan ? '' : Pathname.addSuccessor}
        subTitle={successorText?.description || 'a successor has to be a current viewer'}
        restricted={noPlan || freePlan}
      >
        {
          noPlan || freePlan ? (
            <div className={styles.successorRestrictContainer}>
              <div className={styles.restrictBox}>
                <div className={styles.message}>
                  {freePlanMsg}
                </div>
                <div className={styles.upgradeButton} onClick={() => navigate(Pathname.plans)}>
                  {noPlan ? newPlanAction : freePlanAction}
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.allViewersContainer}>
              {
                successors === undefined ? (
                  <ProjectorShimmer isLight />
                ) : (
                  <div className={styles.viewerList}>
                    <div className={styles.memberHeaderRow}>
                      <span className={styles.memberHeaderName}>
                        <IconUser />
                        Name
                      </span>
                      <span className={styles.memberHeaderEmail}>
                        <IconMail />
                        Email
                      </span>
                      <span className={styles.memberHeaderActions}>
                        <IconActions />
                        Actions
                      </span>
                    </div>
                    {successors?.map(({ id, firstname, lastname, email }, idx) => (
                      <UserRequest
                        email={email}
                        id={id}
                        key={idx}
                        firstname={firstname}
                        lastname={lastname}
                        setSnackbar={setSnackbar}
                        successors={successors}
                      />
                    ))}
                  </div>
                )
              }
            </div>
          )
        }
      </ViewerPage>
      <AddSuccessorModal
        secessionAccount={addSuccessorModal}
        actionAfterAddSuccessor={() => actionAfterAddSuccessor()}
        setSecessionAccount={() => manageSuccessorModal()}
      />
      <Snackbar
        isVisible={snackbar?.isVisible}
        message={snackbar?.message || ''}
        onClose={() => { setSnackbar(defaultSnackbar); }}
        type={snackbar?.type}
      />
    </>
  );
};

export const Successors = (props) => (
  isNewUIEnabled() ? <SuccessorsNew {...props} /> : <SuccessorsClassic {...props} />
);
